import styled from '@emotion/styled'

export const StyledFormDiv = styled('div')`
  margin: 0 48px 15px 48px;
`
export const StyledFormActionDiv = styled('div')`
  position: fixed;
  bottom: 40px;
  width: 100%;
  text-align: center;
  right: 0;
  button {
    @media only screen and (max-width: 768px) {
      width: auto;
      min-width: 100px;
      height: 48px;
      padding: 14px 28px;
      font-size: 16px;
    }
  }
`
